import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Home from './Home/Home';
import Intro from './Intro/intro';
import Lied from './Lied/lied';
import Admin from './admin/admin';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { initializeSecureStorage } from './utils/secureTokenStorage';  



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Initialize secure token storage on app startup
initializeSecureStorage();


root.render(
  <React.StrictMode>
      
    <Router>
    <div className='mt-5'>

      <Routes>
        <Route path='/' element={<Intro  
        // length={function (lenght: any): void {throw new Error('Function not implemented'); }}
        />}/>
         <Route path='/lied/:id' element={<Lied 
        // length={function (lenght: any): void {throw new Error('Function not implemented'); }}
        />}/>
          <Route path='/admin' element={<Admin        // length={function (lenght: any): void {throw new Error('Function not implemented'); }}
        />}/>
        <Route path='/home'  element={<Home lenght={function (lenght: any): void {
            throw new Error('Function not implemented.');
          } }/>}/>
      </Routes>
      </div>
      </Router>
   
  </React.StrictMode> 
);

//<Route path='/start' element={<Intro /> } />
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
